import { Box, Button, Text, TextInput, DataTable, Select } from "grommet";
import React, { useEffect, useState } from "react";
import "./OnlineFormList.css";
import searchIcon from "../../../../../assets/search.svg";
import view from "../../../../../assets/veiw.svg";
import { useStore } from "../../../../../Hooks/useStore";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import Pagination from "../../common/Pagination/Pagination";
import noResult from "../../../../../assets/no-result.png";
import FormSubmit from "../../../../../services/form/formSubmit";

const FormList = observer(() => {
  const { rootStore } = useStore();
  const navigate = useNavigate();

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [originalFormList, setOriginalFormList] = useState([]);
  const [sortedFormList, setSortedFormList] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [ rootFormDataList, setRootFormDataList ] = useState([]);

  const onViewClick = (id) => {
    navigate(`/verifyForm/${id}`)
  };

  useEffect(() => {
    rootStore.loadingStore.setShowLoader(true);
    let user = JSON.parse(localStorage.getItem("userinfo"))
    setTimeout(() => {
      if(user.roleLabel.toLowerCase() === "superadmin") {
        getFormList()
      }
    }, 200);
  },[])

  const getFormList = async () => {
    try {
      const formData = await FormSubmit.getAllForms();
      setRootFormDataList(formData.data)
      setOriginalFormList(formData.data);
      setSortedFormList(formData.data.slice(0, itemsPerPage));
      rootStore.loadingStore.setShowLoader(false);
    } catch (error) {
      console.error("Error fetching forms:", error);
    }
  };

  const onSearchStrChange = (value) => {
    setSearchString(value);
    if (value.trim() === "") {
      setRootFormDataList(originalFormList)
    }
  };

  const onSearch = (value) => {
    const filteredFormList = originalFormList.filter((item) => {
      let matches = false;

      if (item.id && 
        String(item.id).includes(value.toLowerCase())) {
        matches = true;
      }
      if (
        item.createdBy && item.createdBy.toLowerCase().includes(value.toLowerCase())
      ) {
        matches = true;
      }
      if (
        item.createdAt && item.createdAt.toLowerCase().includes(value.toLowerCase())
      ) {
        matches = true;
      }

      return matches;
    });
    setRootFormDataList(filteredFormList);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setSortedFormList(
      originalFormList.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
      )
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch(searchString); // Trigger search when Enter key is pressed
    }
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  
  const visibleFormDataList = rootFormDataList.slice(
    startIndex,
    endIndex
  );

  const showAddSkaliOnboardingGuide = () => {
    navigate("/onboardingGuide");
  };
 

  return (
    <Box className="form-container">
      <Box className="form-header">
        <Box className="form-left-header">
          <Box className="form-search-modal">
            <TextInput
              className="form-search-input"
              onChange={(e) => onSearchStrChange(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Search"
            />
            <img src={searchIcon} className="searchIcon" />
          </Box>
          <Button
            className="form-search-btn"
            label="Search"
            onClick={() => onSearch(searchString)}
          />
        </Box>
        <Box className="form-right-header">
          {/* Add Skali Onboarding Guide Button */}
          <Button
            className="add-form-btn"
            label="Add Skali Onboarding Guide"
            onClick={showAddSkaliOnboardingGuide}
          />
        </Box>
      </Box>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          className="form-table-container"
          style={{ height: visibleFormDataList.length > 0 ? "calc(100% - 0px)" : "auto"}}
        >
          
          <DataTable
            data={visibleFormDataList}
            resizeable
            className="form-datatable"
            paginate={true}
            step={itemsPerPage}
            columns={[
              {
                align:"center",
                property: "name",
                header: <Text>ID</Text>,
                primary: true,
                render: (item) => <Text>{item.id}</Text>,
              },
              {
                align:"center",
                property: "address",
                header: <Text>Created By</Text>,
                primary: true,
                render: (item) => <Text>{item.createdBy}</Text>,
              },
              {
                align:"center",
                property: "phone",
                header: <Text>Time</Text>,
                primary: true,
                render: (item) => <Text>{item.createdAt}</Text>,
              },
              {
                align:"center",
                property: "edit",
                header: <Text>Details</Text>,
                primary: true,
                render: (item) => (
                  <Box
                  direction="row"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 12
                    }}
                  >
                  <button className="details-btn" style={{cursor:"pointer"}}
                   onClick={() => onViewClick(item.id)}
                   >
                    <img src={view} style={{height: 11, width: 16}} alt="View" />
                  </button>
                  </Box>
                ),
              },
            ]}
          />
          {visibleFormDataList.length == 0 && (
                  <Box className="no-result-img">
                    <img src={noResult} alt="no emergency found" style={{width:"27%"}} />
                    <p>No form found.</p>
                  </Box>
                )}
        </Box>
        <Box
          className="form-pagination-container"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          { rootFormDataList.length > itemsPerPage && ( 
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil(
                rootFormDataList.length / itemsPerPage
              )}
              totalItems = {rootFormDataList.length}
              onPageChange={handlePageChange}
              style={{
                position: "sticky",
                bottom: 0,
                zIndex: 1,
                marginTop: "auto",
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
});

export default FormList;
